import { Grid, IconButton, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { AiFillDelete, AiFillEdit } from "react-icons/ai";
import { MdContentCopy } from "react-icons/md";
import { useHistory } from "react-router";
import { BackendTemplate } from "../../model/model/gencode/BackendTemplate";

const useStyle = makeStyles((theme) => ({
	root: {
		background: theme.palette.background.default,
		padding: 10,
		// width: 500,
		borderRadius: 5,
		color: "white",
		margin: 10,
	},
	itemFile: {
		background: theme.palette.primary.main,
		padding: 10,
		borderRadius: 5,
		marginTop: 10,
		cursor: "pointer",
	},
}));
type Props = {
	item: BackendTemplate;
	onDelete: (item: BackendTemplate) => void;
	onEdit: (item: BackendTemplate) => void;
	copyItem: (item: BackendTemplate) => void;
};
export default function BackendTemplateItem(props: Props) {
	const history = useHistory();
	const classes = useStyle();
	return (
		<Grid className={classes.root} xs={12} md={5} lg={3}>
			<Grid
				container
				alignItems="center"
				alignContent="center"
				justify="space-between"
			>
				<Typography variant="h4">{props.item.name}</Typography>
				<Grid>
					<IconButton>
						<AiFillDelete
							onClick={(e) => {
								props.onDelete(props.item);
							}}
						/>
					</IconButton>
					<IconButton
						onClick={(e) => {
							props.onEdit(props.item);
						}}
					>
						<AiFillEdit />
					</IconButton>
					<IconButton
						onClick={(e) => {
							props.copyItem(props.item);
						}}
					>
						<MdContentCopy />
					</IconButton>
				</Grid>
			</Grid>
			<Typography>http://localhost:3000</Typography>
			<Grid>
				{props.item.fileTemplates?.map((item) => (
					<Grid
						className={classes.itemFile}
						onClick={(e) => {
							history.push(
								`/setting-template-detail/${props.item.id}/${item.id}`
							);
						}}
					>
						{item.desc}
					</Grid>
				))}
				<Grid
					className={classes.itemFile}
					onClick={(e) => {
						history.push(
							`/setting-template-detail/${props.item.id}/create`
						);
					}}
				>
					Add new
				</Grid>
			</Grid>
		</Grid>
	);
}
